import { SubmissionDraft } from 'types';
import { CapitolaClient } from './base';

export default class SubmissionDraftClient extends CapitolaClient<SubmissionDraft> {
  public get resourceName(): string {
    return 'submission-draft';
  }
}
